module.exports = __webpack_public_path__ + "img/1557614081208295425.4fd540f5.png";